import React, {useRef, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import {getAvailableWizardVisualizerOptions} from "../../WizardSetupTopVisualizerSelect";
import CheckBox from "../../../PageLayout/CheckBox";
import useOutsideClick from "../../../../utilities/helperHooks";

const WizardPopupEditGroupLeadFormStepSelect = (props) => {

  const {fabricatorSubscriptions, intl} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {visibleInVisualizers} = wizardPopupState;

  const [opened, setOpened] = useState(false);
  const selectElement = useRef(null);

  useOutsideClick(selectElement, () => {
    if (opened) {
      setOpened(false);
    }
  });

  const handleSelectItemClick = (selectItem) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        "visibleInVisualizers": visibleInVisualizers.includes(selectItem.value)
          ? visibleInVisualizers.filter(vis => vis !== selectItem.value)
          : [...visibleInVisualizers, selectItem.value]
      }
    })
  }

  const dropDownItems = getAvailableWizardVisualizerOptions(fabricatorSubscriptions, intl, true);

  const styles = {
    height: opened
      ? (dropDownItems.length * 32) + "px"
      : 0
  }

  const allChecked = !visibleInVisualizers.length || (visibleInVisualizers.length === dropDownItems.length);

  return (
    <div className="wizard-popup__block-input" style={{minWidth: "190px"}}>
      <span className="generic-popup-title">Visible in Visualizers</span>
      <div className={"fc-inst__select select3" + (opened ? " select3--active" : "")}>
        <div className="select2-value" onClick={() => setOpened(true)}>
          {allChecked ? "All" : visibleInVisualizers.map(value => {
            return dropDownItems.find(selItem => selItem.value === value).text
          }).join(", ")}
        </div>
        <div className="select3-dropdown select3-dropdown--white" style={styles} ref={selectElement}>
          <ul className={"select3-dropdown__list"}>
            {dropDownItems.map((selectItem, selectItemIndex) => {
              const checked = visibleInVisualizers.includes(selectItem.value) || allChecked
              return (
                <li className="select3-dropdown__list-item select3-dropdown__list-item--with-checkbox2"
                    key={selectItem.text + selectItemIndex}>
                  <CheckBox checked={checked}
                            innerStyle="none"
                            type={"tiny"}
                            text={selectItem.text}
                            onChecked={() => handleSelectItemClick(selectItem)}/>
                  {/*<span className={"select3-dropdown__list-item-text"}>*/}
                  {/*  {selectItem.text}*/}
                  {/*</span>*/}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup, wizardPopupItem, wizardPopupType} = store.wizardState;
  const {fabricatorSubscriptions} = store.newScope;

  return {
    fabricatorSubscriptions,
    wizardPopupGroup,
    wizardPopupItem,
    wizardPopupType,
  };
};

export default injectIntl(
  connect(mapStateToProps)(WizardPopupEditGroupLeadFormStepSelect)
)
